import { OptionalItemPreview } from 'components/Offer';
import { offer } from 'data';
import { getItemsByCategory } from 'helpers';
import { useSelector } from 'hooks';
import { isEmpty, pick } from 'lodash';
import { styled, css } from 'mymoria-ui';
import React from 'react';
import { Product, ProductCategory } from 'types';
import FavoriteProductsPreview from './FavoriteProductsPreview';
import OfferPageCard from './OfferPageCard';

const StyledCard = styled(OfferPageCard)(
  ({ title }) => css`
    //TODO: Can we have another card variant?
    && {
      padding: 1.5rem 0;
    }

    ${title &&
    `
      & > div:first-of-type {
        padding: 0 1.5rem;
        margin-bottom: 1rem;
      }
    `}
  `,
);

const OptionalItemsCard = () => {
  const services = useSelector(({ services: { optional } }) => optional);
  const products = useSelector(({ proposal: { optionalProducts } }) => optionalProducts);
  const allProducts = useSelector(({ entities: { products } }) => products);
  const optionalProducts = pick(allProducts, products);

  const flowers = getItemsByCategory(optionalProducts, 'flower');
  const cards = getItemsByCategory(optionalProducts, 'card');
  const notice = getItemsByCategory(optionalProducts, 'notice');
  const graveGoods = getItemsByCategory(optionalProducts, 'grave_goods');
  const graveCross = getItemsByCategory(optionalProducts, 'graveCross');
  const keepsake = getItemsByCategory(optionalProducts, 'keepsake');

  // Helper function to handle rendering optional items and favorite card
  const renderProductsWithFavoriteCard = (items: Product[], category: ProductCategory) => {
    if (isEmpty(items)) {
      return (
        <FavoriteProductsPreview type="products" category={category} selectedItem={undefined} />
      );
    }

    return items.map(({ id, articleNumber }, index) => (
      <React.Fragment key={articleNumber}>
        <OptionalItemPreview id={id} type="products">
          {selectedItem => {
            if (items.length > 0 && index === items.length - 1) {
              return (
                <FavoriteProductsPreview
                  type="products"
                  category={category}
                  selectedItem={selectedItem}
                />
              );
            }
          }}
        </OptionalItemPreview>
      </React.Fragment>
    ));
  };

  const items = [
    renderProductsWithFavoriteCard(flowers, 'flower'),
    ...services.slice(0, 3).map(id => <OptionalItemPreview key={id} id={id} type="services" />),
    renderProductsWithFavoriteCard(cards, 'card'),
    renderProductsWithFavoriteCard(notice, 'notice'),
    renderProductsWithFavoriteCard(keepsake, 'keepsake'),
    ...services.slice(3, 4).map(id => <OptionalItemPreview key={id} id={id} type="services" />),
    ...graveCross.map(({ id }) => <OptionalItemPreview key={id} id={id} type="products" />),
    ...graveGoods.map(({ id }) => <OptionalItemPreview key={id} id={id} type="products" />),
    ...services.slice(4).map(id => <OptionalItemPreview key={id} id={id} type="services" />),
  ];

  if (items.length === 0) {
    return null;
  }

  return (
    <StyledCard title={offer.offerDetails.othersTitle} variant="small">
      {items}
    </StyledCard>
  );
};

export default OptionalItemsCard;
